import _ from 'lodash';
import { createReducer } from '../../../common/reduxHelpers';
import * as types from './actionTypes';
import { setIn, mergeIn } from 'immutable-light';

const setOTTStatus = isLoading => (state, action) =>
    _.assign({}, state, {
        OTTStatus: _.assign({}, state.OTTStatus, {
            isLoading,
            value: action.response
        })
    });

const setSMSData = (status, buttonEnabled) => (state, action) =>
    _.assign({}, state, {
        SMSData: _.assign({}, state.SMSData, {
            status,
            smsText: status === "send_success" ? "" : state.SMSData.smsText,
            buttonEnabled
        })
    });

export const emptyUpdateForm = {
    isLoading: false,
    isSuccessful: true,
    externalReference: null
};

export const initialState = {

    profileData: {
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        mobilePhone: '',
        birthDate: '',
        addresses: [],
        customerClass: '',
        type: '',
        loadingStatus: '',
        externalReference: ''
    },

    updateForm: emptyUpdateForm,

    OTTStatus: {
        isLoading: false,
        value: ''
    },
    SMSData: {
        smsText: '',
        phoneNumber: '',
        status: '',
        buttonEnabled: false
    }
};

const reducer = createReducer(initialState, {
    [types.FETCH_PROFILE_REQUEST]: (state, action) => setIn(state, ['profileData'], { loadingStatus: 'loading', email: '', id: '' }),
    [types.FETCH_PROFILE_SUCCESS]: (state, action) => setIn(state, ['profileData'], { ...action.response, loadingStatus: 'loaded' }),
    [types.FETCH_PROFILE_FAILURE]: (state, action) => setIn(state, ['profileData'], { ...initialState.profileData, loadingStatus: 'failed' }),
    [types.SEND_SMS_REQUEST]: setSMSData("send_request", false),
    [types.SEND_SMS_SUCCESS]: setSMSData("send_success", true),
    [types.SEND_SMS_FAILURE]: setSMSData("send_failure", true),
    [types.FETCH_OTTSTATUS_REQUEST]: setOTTStatus(true),
    [types.FETCH_OTTSTATUS_SUCCESS]: setOTTStatus(false),
    [types.FETCH_OTTSTATUS_FAILURE]: setOTTStatus(false),
    [types.TOGGLE_SMS_BUTTON](state, action) {
        return _.assign({}, state, {
            SMSData: _.assign({}, state.SMSData, {
                buttonEnabled: action.buttonEnabled
            })
        });
    },
    [types.UPDATE_FORM_SET_PROPERTY]: (state, action) => mergeIn(state, ['updateForm'], { [action.propertyName]: action.propertyValue }),
    [types.UPDATE_FORM_CLEAR]: (state, action) => setIn(state, ['updateForm'], emptyUpdateForm),
    [types.UPDATE_CUSTOMER_REQUEST]: (state, action) => mergeIn(state, ['updateForm'], {isLoading: true, isSuccessful: false }),
    [types.UPDATE_CUSTOMER_SUCCESS]: (state, action) => mergeIn(state, ['updateForm'], {isLoading: false, isSuccessful: true}),
    [types.UPDATE_CUSTOMER_FAILURE]: (state, action) => mergeIn(state, ['updateForm'], {isLoading: false, isSuccessful: false}),
    // [types.SAVE_START]: (state, action) => setIn(state, ['saving'], true),
    // [types.SAVE_STOP]: (state, action) => setIn(state, ['saving'], false),
});

export default reducer;